export const basePath = new URL(document.baseURI).pathname;
